import { FlexCenter } from 'styled';
import styled from 'styled-components';

export const Container = styled(FlexCenter)`
  min-height: 400px;
`;
